/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2026 (original work) Open Assessment Technologies SA ;
 */

import config from '@/config';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { FEATURE_PAPER_SESSIONS } from '@/constants/features.js';

export const routing = [
    {
        path: [config.routes.paperSessions.list],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_PAPER_SESSIONS),
            getPermissionsGuard([
                { resource: 'portal.paper-scans', scopes: ['view'] },
                { resource: 'portal.paperbased-session', scopes: ['view'] }
            ])
        ]),
        controller: () => import('./controllers/paperSessions')
    },
    {
        path: [config.routes.paperSessions.details],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_PAPER_SESSIONS),
            getPermissionsGuard([{ resource: 'portal.paper-scans', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/paperSessionsDetails')
    }
];
